'use client'

import { useEffect, useId, useRef } from 'react'

export default function Mermaid({ chart }: { chart: string }) {
  const id = useId()
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    let cancelled = false
    import('mermaid').then(({ default: mermaid }) => {
      if (cancelled || !ref.current) return
      mermaid.initialize({ startOnLoad: false, theme: 'neutral' })
      mermaid
        .render(`mermaid-${id.replace(/:/g, '')}`, chart)
        .then(({ svg }) => {
          if (!cancelled && ref.current) ref.current.innerHTML = svg
        })
    })
    return () => {
      cancelled = true
    }
  }, [chart, id])

  return <div ref={ref} className="my-4 overflow-x-auto" />
}
